module.exports = __webpack_public_path__ + "static/bg_1-5ffe2429742d7a7e3343c0f9a8c9b90e.jpg";